import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="main-footer">
      <span>&copy; 2025. WTI. All Rights Reserved.</span>
      <span>Created by: <Link to="https://www.facebook.com/yukeepm" target="_blank">Sulkiflee Masa</Link></span>
    </div>
  )
}